'use client';

import { ThemeProvider as NextThemesProvider } from 'next-themes';

/**
 * Провайдер темы (светлая/тёмная/системная)
 */
export function ThemeProvider(props: React.PropsWithChildren) {
  return (
    <NextThemesProvider attribute="class" defaultTheme="dark" enableSystem {...props} />
  );
}
